import PropTypes from 'prop-types';
import { IconTrash } from '@tabler/icons-react';
import classes from './deleteButton.module.css';

const DeleteButton = (props) => {
  const { onClick, variant } = props;

  return (
    <button className={`${classes.button} ${classes[variant]}`} onClick={onClick}>
      <IconTrash className={classes.icon} />
    </button>
  );
};

DeleteButton.propTypes = {
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(['light']),
};

export default DeleteButton;
